import script from "./TransactionClassificationsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransactionClassificationsPage.vue?vue&type=script&setup=true&lang=ts"

import "./TransactionClassificationsPage.vue?vue&type=style&index=0&id=3133f84e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3133f84e"]])

export default __exports__